(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birthday-sale-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rb-birthday-ribbon')) {
  customElements.define('rb-birthday-ribbon', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.statusNode = this.querySelector('[data-status]');
      this.clock = this.querySelector('[data-clock]');
      this.cta = this.querySelector('[data-cta]');
      this.originalHref = this.cta.getAttribute('href');
      this.pause = this.querySelector('[data-pause]');
      const parse = value => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      this.start = parse(this.dataset.start || '');
      const explicitEnd = this.dataset.end || '';
      this.end = explicitEnd ? parse(explicitEnd) : this.start + Number(this.dataset.duration) * 86400000;
      this.configured = Number.isFinite(this.start) && Number.isFinite(this.end) && this.end > this.start;
      this.manualPause = false;
      this.visible = true;
      this.visibilityHandler = () => { this.motion(); this.schedule(); };
      this.pauseHandler = () => { this.manualPause = !this.manualPause; this.motion(); };
      this.ctaHandler = event => { if (this.cta.getAttribute('aria-disabled') === 'true') event.preventDefault(); };
      this.cta.addEventListener('click', this.ctaHandler);
      if (this.pause) { this.pause.hidden = false; this.pause.addEventListener('click', this.pauseHandler); }
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.motion(); this.schedule(); });
      this.observer.observe(this);
      this.schedule();
    }
    motion() {
      this.toggleAttribute('data-paused', this.manualPause || !this.visible || document.hidden);
      if (this.pause) {
        this.pause.setAttribute('aria-pressed', String(this.manualPause));
        this.pause.textContent = this.manualPause ? this.pause.dataset.play : this.pause.dataset.pauseLabel;
      }
    }
    schedule() {
      clearInterval(this.timer);
      this.tick();
      if (this.configured && this.end > Date.now() && this.visible && !document.hidden) this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const now = Date.now();
      const state = !this.configured ? 'unscheduled' : now < this.start ? 'soon' : now >= this.end ? 'ended' : 'active';
      if (state !== this.state) {
        this.state = state;
        this.statusNode.textContent = this.statusNode.dataset[state];
        const enabled = state === 'active';
        this.cta.setAttribute('aria-disabled', String(!enabled));
        if (enabled) { this.cta.setAttribute('href', this.originalHref); this.cta.removeAttribute('tabindex'); }
        else { this.cta.removeAttribute('href'); this.cta.setAttribute('tabindex', '-1'); }
        this.clock.hidden = state === 'unscheduled';
        const note = this.querySelector('[data-editor]');
        if (note) note.hidden = this.configured;
      }
      if (!this.configured) return;
      const target = state === 'soon' ? this.start : this.end;
      const seconds = Math.max(0, Math.ceil((target - now) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      ['days', 'hours', 'minutes', 'seconds'].forEach((unit, i) => { this.querySelector('[data-' + unit + ']').textContent = String(values[i]).padStart(2, '0'); });
      if (state === 'ended') clearInterval(this.timer);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.pause?.removeEventListener('click', this.pauseHandler);
      this.cta?.removeEventListener('click', this.ctaHandler);
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
